interface UpdateErrorLike {
  message?: unknown
  ipcErrorType?: unknown
}

export interface UpdateErrorSummary {
  errorType: string
  message: string
}

function redactUrl(value: string): string {
  return value.replace(/https?:\/\/[^\s)]+/g, (rawUrl) => {
    try {
      const url = new URL(rawUrl)
      return `${url.origin}${url.pathname}`
    } catch {
      return '[url]'
    }
  })
}

function isSensitiveErrorKey(key: string): boolean {
  return /token|authorization|credential|secret|password|key/i.test(key)
}

function readErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (typeof error === 'object' && error !== null) {
    return Object.entries(error as Record<string, unknown>)
      .filter(([key]) => !isSensitiveErrorKey(key))
      .map(([, value]) => value)
      .filter((value) => typeof value === 'string' || typeof value === 'number')
      .join(': ')
  }
  return String(error)
}

function readErrorType(error: unknown): string {
  if (typeof error !== 'object' || error === null) return 'unknown'
  const typed = error as UpdateErrorLike
  return typeof typed.ipcErrorType === 'string' && typed.ipcErrorType
    ? typed.ipcErrorType
    : 'unknown'
}

export function summarizeUpdateError(error: unknown): UpdateErrorSummary {
  return {
    errorType: readErrorType(error),
    message: redactUrl(readErrorMessage(error)).slice(0, 200),
  }
}

export function updateCheckUserMessage(error: unknown): string {
  const summary = summarizeUpdateError(error)
  if (summary.message && summary.message !== '[object Object]') {
    return summary.message
  }
  switch (summary.errorType) {
    case 'Auth':
    case 'TokenExpired':
      return '登录信息已失效，请重新登录'
    case 'Validation':
      return '当前账号暂无此版本更新资格'
    case 'Network':
      return '网络连接异常，请检查网络后重试'
    case 'Internal':
      return '更新服务暂不可用，请稍后重试'
    default:
      return '检查更新失败，请稍后重试'
  }
}
